var nav_breakpoint = '1280px';
var previous_padding_top = '';
var header = document.getElementsByTagName('header')[0];
var mobile_menu = document.getElementById('mobile-menu');
var mobile_toggle = document.getElementById('mobile-toggle');
var context = document.getElementById('mobile-context');
var context_title = document.getElementById('mobile-context-title');

var focusTrap = require('focus-trap');

var enable_focus_trap = true;
var parent_trap = focusTrap.createFocusTrap(['header', '#mobile-menu']);
var child_trap;
document.addEventListener('click', function (event) {
  // Only run on our select menu
  if (!event.target.matches('.hamburger-menu')) return;
  header = document.getElementsByTagName('header')[0];
  mobile_menu = document.getElementById('mobile-menu');
  mobile_toggle = document.getElementById('mobile-toggle');

  if (!document.body.classList.contains('mobile-menu-active') && mobile_menu) {
    open_menu();
  } else if (mobile_menu) {
    close_menu();
  }
});
document.addEventListener('click', function (event) {
  //if the mobile nav is visible
  if (window.matchMedia('(max-width: ' + nav_breakpoint + ')').matches) {
    var target = event.target.matches('.menu-item-has-children') ? event.target : event.target.parentNode.classList.contains('menu-item-has-children') ? event.target.parentNode : false; // Only run on our select menu

    if (target) {
      event.preventDefault();
      mobile_navigation_controller(target);
    }
  }
});
document.addEventListener('click', function (event) {
  //if the mobile nav is visible
  if (window.matchMedia('(max-width: ' + nav_breakpoint + ')').matches) {
    // Only run on our select menu
    if (!event.target.matches('.sub-menu-back')) return;
    var active_menu = document.getElementsByClassName('sliding-submenu');

    if (active_menu[0]) {
      var sub_menu = active_menu[0].getElementsByClassName('keyboard-nav-toggle');

      if (sub_menu[0]) {
        mobile_navigation_controller(sub_menu[0]);
      }
    }
  }
});

var debounce = require('debounce');

window.addEventListener('resize', debounce(function (e) {
  if (window.matchMedia('(min-width: ' + nav_breakpoint + ')').matches && document.body.classList.contains('mobile-menu-active')) {
    close_menu();
  }
}, 200));
export function open_menu() {
  mobile_toggle.classList.add('animate');
  document.body.classList.add('mobile-menu-active');

  if (enable_focus_trap) {
    parent_trap.activate();
  }

  mobile_menu.classList.remove('invisible');
  setTimeout(function () {
    mobile_menu.classList.remove('scroll-lock');
  }, 300);
}
export function close_menu() {
  mobile_toggle.classList.remove('animate');
  document.body.classList.remove('mobile-menu-active');

  if (enable_focus_trap) {
    parent_trap.deactivate();

    if (child_trap) {
      child_trap.deactivate();
    }
  }

  context.classList.add('hidden');
  setTimeout(function () {
    mobile_menu.classList.add('invisible');
    mobile_menu.classList.add('scroll-lock');
    var active_link_items = mobile_menu.querySelectorAll('.keyboard-nav-toggle, .sliding-submenu');

    if (active_link_items.length) {
      for (var i = 0; i < active_link_items.length; i++) {
        active_link_items[i].classList.remove('keyboard-nav-toggle');
        active_link_items[i].classList.remove('sliding-submenu');
      }
    }
  }, 300);
}

function mobile_navigation_controller(li) {
  //find any open items
  var open_items = document.getElementsByClassName('keyboard-nav-toggle'); //if we have some items...

  if (open_items.length > 0) {
    //loop through the open items
    for (var i = 0; i < open_items.length; i++) {
      //if the current item isn't the one we're clicking on...
      if (open_items[i] != li) {
        //remove the class
        open_items[i].classList.remove('keyboard-nav-toggle');
      }
    }
  } //add a class indicating it's been toggled


  li.classList.toggle('keyboard-nav-toggle'); //if this is a sliding menu...

  if (li.classList.contains('sub-menu-icons') || li.classList.contains('sub-menu-images')) {
    var url = li.childNodes[0].getAttribute('href'); // Check if the URL is not just a hash link

    if (url && url !== '#' && !url.endsWith('/#')) {
      context_title.innerHTML = "<a href=\"".concat(url, "\">").concat(li.childNodes[0].innerHTML, "</a>");
    } else {
      context_title.innerHTML = li.childNodes[0].innerHTML || 'Menu';
    }

    context.classList.toggle('hidden'); //toggle the classic

    li.parentNode.classList.toggle('sliding-submenu'); //if we're enabling focus trap...

    if (enable_focus_trap) {
      //if we're opening the menu...
      if (li.classList.contains('keyboard-nav-toggle')) {
        //create a new focus trap
        child_trap = focusTrap.createFocusTrap(['header', context, li.childNodes[2]]); //pause the parent trap

        parent_trap.pause(); //activate the focus trap

        child_trap.activate();
      } else {
        (function () {
          //if we're closing the menu...
          //unpause the parent trap
          parent_trap.unpause(); //deactivate the focus trap

          child_trap.deactivate(); //find all the links in the menu

          var tags = li.getElementsByTagName('a'); //loop through the links

          var _loop = function _loop(_i) {
            //set the tabindex to -1 to prevent any weirdness
            tags[_i].tabIndex = -1; //in 300s when our animations are complete

            setTimeout(function () {
              //remove the tabindex
              tags[_i].removeAttribute('tabindex');
            }, 600);
          };

          for (var _i = 0; _i < tags.length; _i++) {
            _loop(_i);
          }
        })();
      }
    }
  }
}

document.addEventListener('keydown', function (event) {
  if (event.code == "Escape") {
    close_menu();
  }
});